import { Component, Input, OnInit, inject } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { NgSelectModule } from "@ng-select/ng-select";
import { ControlDetailOverviewModel } from "./ControlDetailOverviewModel";
import { TabService } from "@services/tabs/TabService";
import { Pages } from "@constants/pages/Pages";
import { ModuleType } from "@enums/ModuleType";
import { ControlDetailOverviewDataService } from "./control-detail-overview.data.service";
import { TranslatePipe, provideTranslationScope } from "@app/shared/i18n/translation-scope";
import { scope } from "@app/controls/i18n/scope";
import { DateInputComponent } from "@app/shared/components/date-input/date-input.component";
import { InputTooltipDirective } from "@app/shared/directives/input-tooltip.directive";

@Component({
    selector: "control-detail-overview",
    templateUrl: "./control-detail-overview.component.html",
    styleUrls: ["./control-detail-overview.component.scss"],
    imports: [FormsModule, NgSelectModule, DateInputComponent, InputTooltipDirective, TranslatePipe],
    viewProviders: [provideTranslationScope(scope)],
})
export class ControlDetailOverviewComponent implements OnInit {
    private _controlDetailOverviewDS = inject(ControlDetailOverviewDataService);
    private _tabService = inject(TabService);
    private _pages = inject(Pages);

    @Input() ControlGuid: string;
    @Input() Label: string;

    @Input() ParentModule: ModuleType;
    @Input() ParentGuid: string;

    @Input() HideControlDetails: boolean;
    @Input() HideDesignScore: boolean;
    @Input() HideEffectivenessScore: boolean;
    @Input() HideOpenControlButton: boolean;

    overviewModel: ControlDetailOverviewModel;

    ngOnInit(): void {
        if (this.ParentModule && this.ParentGuid) {
            this._controlDetailOverviewDS
                .getControlOverviewWithModule(this.ControlGuid, this.ParentModule, this.ParentGuid)
                .subscribe((x) => {
                    this.overviewModel = x;
                });
        } else {
            this._controlDetailOverviewDS.getControlOverview(this.ControlGuid).subscribe((x) => {
                this.overviewModel = x;
            });
        }
    }

    openControl(): void {
        if (!this.HideOpenControlButton) {
            this._tabService.generateTab(this._pages.ControlDetail, this.ControlGuid);
        }
    }
}
